"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _price = _interopRequireDefault(require("@gravity/price"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _product = require("@nucleo/product");
var _icons = _interopRequireDefault(require("./icons"));
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductColumnType.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2fup6np0g4() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductColumnType.js";
  var hash = "5e33594a5f2f80933473389ddddef2de46ee70a5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductColumnType.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 15,
          column: 20
        }
      },
      "1": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "2": {
        start: {
          line: 20,
          column: 30
        },
        end: {
          line: 20,
          column: 61
        }
      },
      "3": {
        start: {
          line: 21,
          column: 31
        },
        end: {
          line: 21,
          column: 69
        }
      },
      "4": {
        start: {
          line: 45,
          column: 16
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "5": {
        start: {
          line: 46,
          column: 36
        },
        end: {
          line: 46,
          column: 93
        }
      },
      "6": {
        start: {
          line: 61,
          column: 21
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "7": {
        start: {
          line: 69,
          column: 13
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "8": {
        start: {
          line: 77,
          column: 13
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "9": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 80,
          column: 39
        }
      },
      "10": {
        start: {
          line: 87,
          column: 29
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "11": {
        start: {
          line: 90,
          column: 23
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "12": {
        start: {
          line: 94,
          column: 20
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "13": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 98,
          column: 39
        }
      },
      "14": {
        start: {
          line: 102,
          column: 24
        },
        end: {
          line: 113,
          column: 1
        }
      },
      "15": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 97
        }
      },
      "16": {
        start: {
          line: 114,
          column: 24
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "17": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 119,
          column: 39
        }
      },
      "18": {
        start: {
          line: 122,
          column: 19
        },
        end: {
          line: 133,
          column: 1
        }
      },
      "19": {
        start: {
          line: 128,
          column: 31
        },
        end: {
          line: 128,
          column: 60
        }
      },
      "20": {
        start: {
          line: 135,
          column: 18
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "21": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 143,
          column: 10
        }
      },
      "22": {
        start: {
          line: 151,
          column: 13
        },
        end: {
          line: 157,
          column: 1
        }
      },
      "23": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 154,
          column: 39
        }
      },
      "24": {
        start: {
          line: 160,
          column: 14
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "25": {
        start: {
          line: 168,
          column: 13
        },
        end: {
          line: 175,
          column: 1
        }
      },
      "26": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 171,
          column: 39
        }
      },
      "27": {
        start: {
          line: 177,
          column: 21
        },
        end: {
          line: 184,
          column: 1
        }
      },
      "28": {
        start: {
          line: 191,
          column: 29
        },
        end: {
          line: 202,
          column: 1
        }
      },
      "29": {
        start: {
          line: 192,
          column: 2
        },
        end: {
          line: 201,
          column: 3
        }
      },
      "30": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 45
        }
      },
      "31": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 44
        }
      },
      "32": {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 198,
          column: 45
        }
      },
      "33": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 45
        }
      },
      "34": {
        start: {
          line: 205,
          column: 25
        },
        end: {
          line: 205,
          column: 41
        }
      },
      "35": {
        start: {
          line: 207,
          column: 20
        },
        end: {
          line: 207,
          column: 95
        }
      },
      "36": {
        start: {
          line: 207,
          column: 29
        },
        end: {
          line: 207,
          column: 95
        }
      },
      "37": {
        start: {
          line: 209,
          column: 15
        },
        end: {
          line: 223,
          column: 1
        }
      },
      "38": {
        start: {
          line: 210,
          column: 23
        },
        end: {
          line: 210,
          column: 85
        }
      },
      "39": {
        start: {
          line: 212,
          column: 31
        },
        end: {
          line: 212,
          column: 63
        }
      },
      "40": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 77
        }
      },
      "41": {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 17
        }
      },
      "42": {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 242,
          column: 6
        }
      },
      "43": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 90
        }
      },
      "44": {
        start: {
          line: 246,
          column: 32
        },
        end: {
          line: 246,
          column: 87
        }
      },
      "45": {
        start: {
          line: 249,
          column: 57
        },
        end: {
          line: 249,
          column: 67
        }
      },
      "46": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 336,
          column: 5
        }
      },
      "47": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 257,
          column: 10
        }
      },
      "48": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 266,
          column: 10
        }
      },
      "49": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 299,
          column: 10
        }
      },
      "50": {
        start: {
          line: 288,
          column: 72
        },
        end: {
          line: 288,
          column: 96
        }
      },
      "51": {
        start: {
          line: 291,
          column: 73
        },
        end: {
          line: 291,
          column: 97
        }
      },
      "52": {
        start: {
          line: 301,
          column: 8
        },
        end: {
          line: 308,
          column: 10
        }
      },
      "53": {
        start: {
          line: 310,
          column: 8
        },
        end: {
          line: 319,
          column: 10
        }
      },
      "54": {
        start: {
          line: 321,
          column: 8
        },
        end: {
          line: 325,
          column: 10
        }
      },
      "55": {
        start: {
          line: 327,
          column: 8
        },
        end: {
          line: 333,
          column: 10
        }
      },
      "56": {
        start: {
          line: 335,
          column: 8
        },
        end: {
          line: 335,
          column: 27
        }
      },
      "57": {
        start: {
          line: 340,
          column: 0
        },
        end: {
          line: 349,
          column: 2
        }
      },
      "58": {
        start: {
          line: 351,
          column: 0
        },
        end: {
          line: 353,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 21
          }
        },
        loc: {
          start: {
            line: 20,
            column: 30
          },
          end: {
            line: 20,
            column: 61
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 21,
            column: 22
          }
        },
        loc: {
          start: {
            line: 21,
            column: 31
          },
          end: {
            line: 21,
            column: 69
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 46,
            column: 26
          },
          end: {
            line: 46,
            column: 27
          }
        },
        loc: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 46,
            column: 93
          }
        },
        line: 46
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 78,
            column: 11
          },
          end: {
            line: 78,
            column: 12
          }
        },
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 80,
            column: 39
          }
        },
        line: 79
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 96,
            column: 11
          },
          end: {
            line: 96,
            column: 12
          }
        },
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        },
        line: 97
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 110,
            column: 13
          }
        },
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 97
          }
        },
        line: 111
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 117,
            column: 11
          },
          end: {
            line: 117,
            column: 12
          }
        },
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 119,
            column: 39
          }
        },
        line: 118
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 128,
            column: 22
          },
          end: {
            line: 128,
            column: 23
          }
        },
        loc: {
          start: {
            line: 128,
            column: 31
          },
          end: {
            line: 128,
            column: 60
          }
        },
        line: 128
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 23
          }
        },
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 143,
            column: 10
          }
        },
        line: 141
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 152,
            column: 11
          },
          end: {
            line: 152,
            column: 12
          }
        },
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 154,
            column: 39
          }
        },
        line: 153
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 169,
            column: 11
          },
          end: {
            line: 169,
            column: 12
          }
        },
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 171,
            column: 39
          }
        },
        line: 170
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 191,
            column: 29
          },
          end: {
            line: 191,
            column: 30
          }
        },
        loc: {
          start: {
            line: 191,
            column: 37
          },
          end: {
            line: 202,
            column: 1
          }
        },
        line: 191
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 207,
            column: 20
          },
          end: {
            line: 207,
            column: 21
          }
        },
        loc: {
          start: {
            line: 207,
            column: 29
          },
          end: {
            line: 207,
            column: 95
          }
        },
        line: 207
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 210,
            column: 13
          },
          end: {
            line: 210,
            column: 14
          }
        },
        loc: {
          start: {
            line: 210,
            column: 23
          },
          end: {
            line: 210,
            column: 85
          }
        },
        line: 210
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 212,
            column: 22
          },
          end: {
            line: 212,
            column: 23
          }
        },
        loc: {
          start: {
            line: 212,
            column: 31
          },
          end: {
            line: 212,
            column: 63
          }
        },
        line: 212
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 217,
            column: 5
          }
        },
        loc: {
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 218,
            column: 77
          }
        },
        line: 218
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 238,
            column: 2
          },
          end: {
            line: 238,
            column: 3
          }
        },
        loc: {
          start: {
            line: 238,
            column: 21
          },
          end: {
            line: 243,
            column: 3
          }
        },
        line: 238
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 245,
            column: 3
          }
        },
        loc: {
          start: {
            line: 245,
            column: 22
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 245
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 246,
            column: 18
          },
          end: {
            line: 246,
            column: 19
          }
        },
        loc: {
          start: {
            line: 246,
            column: 32
          },
          end: {
            line: 246,
            column: 87
          }
        },
        line: 246
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 248,
            column: 2
          },
          end: {
            line: 248,
            column: 3
          }
        },
        loc: {
          start: {
            line: 248,
            column: 11
          },
          end: {
            line: 337,
            column: 3
          }
        },
        line: 248
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 288,
            column: 66
          },
          end: {
            line: 288,
            column: 67
          }
        },
        loc: {
          start: {
            line: 288,
            column: 72
          },
          end: {
            line: 288,
            column: 96
          }
        },
        line: 288
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 291,
            column: 67
          },
          end: {
            line: 291,
            column: 68
          }
        },
        loc: {
          start: {
            line: 291,
            column: 73
          },
          end: {
            line: 291,
            column: 97
          }
        },
        line: 291
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 30
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 45
          },
          end: {
            line: 20,
            column: 53
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 31
          },
          end: {
            line: 21,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 46
          },
          end: {
            line: 21,
            column: 54
          }
        }, {
          start: {
            line: 21,
            column: 57
          },
          end: {
            line: 21,
            column: 69
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 46,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 71
          },
          end: {
            line: 46,
            column: 88
          }
        }, {
          start: {
            line: 46,
            column: 91
          },
          end: {
            line: 46,
            column: 93
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 46,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 46,
            column: 47
          }
        }, {
          start: {
            line: 46,
            column: 51
          },
          end: {
            line: 46,
            column: 68
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 80,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 5
          },
          end: {
            line: 79,
            column: 16
          }
        }, {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 79,
            column: 39
          }
        }, {
          start: {
            line: 79,
            column: 43
          },
          end: {
            line: 79,
            column: 79
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 39
          }
        }],
        line: 79
      },
      "5": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 5
          },
          end: {
            line: 97,
            column: 16
          }
        }, {
          start: {
            line: 97,
            column: 20
          },
          end: {
            line: 97,
            column: 39
          }
        }, {
          start: {
            line: 97,
            column: 43
          },
          end: {
            line: 97,
            column: 79
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        }],
        line: 97
      },
      "6": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 7
          },
          end: {
            line: 111,
            column: 25
          }
        }, {
          start: {
            line: 111,
            column: 29
          },
          end: {
            line: 111,
            column: 56
          }
        }, {
          start: {
            line: 111,
            column: 61
          },
          end: {
            line: 111,
            column: 97
          }
        }],
        line: 111
      },
      "7": {
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 119,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 5
          },
          end: {
            line: 118,
            column: 16
          }
        }, {
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 118,
            column: 39
          }
        }, {
          start: {
            line: 118,
            column: 43
          },
          end: {
            line: 118,
            column: 79
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 39
          }
        }],
        line: 118
      },
      "8": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 143,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 901
          }
        }, {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 10
          }
        }],
        line: 141
      },
      "9": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 154,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 5
          },
          end: {
            line: 153,
            column: 16
          }
        }, {
          start: {
            line: 153,
            column: 20
          },
          end: {
            line: 153,
            column: 39
          }
        }, {
          start: {
            line: 153,
            column: 43
          },
          end: {
            line: 153,
            column: 79
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 39
          }
        }],
        line: 153
      },
      "10": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 171,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 5
          },
          end: {
            line: 170,
            column: 16
          }
        }, {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 170,
            column: 39
          }
        }, {
          start: {
            line: 170,
            column: 43
          },
          end: {
            line: 170,
            column: 79
          }
        }, {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 171,
            column: 39
          }
        }],
        line: 170
      },
      "11": {
        loc: {
          start: {
            line: 192,
            column: 2
          },
          end: {
            line: 201,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 194,
            column: 45
          }
        }, {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 196,
            column: 44
          }
        }, {
          start: {
            line: 197,
            column: 4
          },
          end: {
            line: 198,
            column: 45
          }
        }, {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 200,
            column: 45
          }
        }],
        line: 192
      },
      "12": {
        loc: {
          start: {
            line: 207,
            column: 29
          },
          end: {
            line: 207,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 207,
            column: 30
          },
          end: {
            line: 207,
            column: 48
          }
        }, {
          start: {
            line: 207,
            column: 52
          },
          end: {
            line: 207,
            column: 79
          }
        }, {
          start: {
            line: 207,
            column: 84
          },
          end: {
            line: 207,
            column: 95
          }
        }],
        line: 207
      },
      "13": {
        loc: {
          start: {
            line: 210,
            column: 23
          },
          end: {
            line: 210,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 36
          },
          end: {
            line: 210,
            column: 80
          }
        }, {
          start: {
            line: 210,
            column: 83
          },
          end: {
            line: 210,
            column: 85
          }
        }],
        line: 210
      },
      "14": {
        loc: {
          start: {
            line: 250,
            column: 4
          },
          end: {
            line: 336,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 257,
            column: 10
          }
        }, {
          start: {
            line: 258,
            column: 6
          },
          end: {
            line: 266,
            column: 10
          }
        }, {
          start: {
            line: 267,
            column: 6
          },
          end: {
            line: 299,
            column: 10
          }
        }, {
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 308,
            column: 10
          }
        }, {
          start: {
            line: 309,
            column: 6
          },
          end: {
            line: 319,
            column: 10
          }
        }, {
          start: {
            line: 320,
            column: 6
          },
          end: {
            line: 325,
            column: 10
          }
        }, {
          start: {
            line: 326,
            column: 6
          },
          end: {
            line: 333,
            column: 10
          }
        }, {
          start: {
            line: 334,
            column: 6
          },
          end: {
            line: 335,
            column: 27
          }
        }],
        line: 250
      },
      "15": {
        loc: {
          start: {
            line: 255,
            column: 27
          },
          end: {
            line: 255,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 255,
            column: 28
          },
          end: {
            line: 255,
            column: 39
          }
        }, {
          start: {
            line: 255,
            column: 43
          },
          end: {
            line: 255,
            column: 59
          }
        }, {
          start: {
            line: 255,
            column: 64
          },
          end: {
            line: 255,
            column: 66
          }
        }],
        line: 255
      },
      "16": {
        loc: {
          start: {
            line: 272,
            column: 17
          },
          end: {
            line: 273,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 272,
            column: 17
          },
          end: {
            line: 272,
            column: 35
          }
        }, {
          start: {
            line: 273,
            column: 18
          },
          end: {
            line: 273,
            column: 47
          }
        }, {
          start: {
            line: 273,
            column: 51
          },
          end: {
            line: 273,
            column: 79
          }
        }],
        line: 272
      },
      "17": {
        loc: {
          start: {
            line: 274,
            column: 17
          },
          end: {
            line: 275,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 274,
            column: 17
          },
          end: {
            line: 274,
            column: 35
          }
        }, {
          start: {
            line: 275,
            column: 18
          },
          end: {
            line: 275,
            column: 49
          }
        }, {
          start: {
            line: 275,
            column: 53
          },
          end: {
            line: 275,
            column: 83
          }
        }],
        line: 274
      },
      "18": {
        loc: {
          start: {
            line: 276,
            column: 17
          },
          end: {
            line: 277,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 276,
            column: 17
          },
          end: {
            line: 276,
            column: 35
          }
        }, {
          start: {
            line: 277,
            column: 18
          },
          end: {
            line: 277,
            column: 48
          }
        }, {
          start: {
            line: 277,
            column: 52
          },
          end: {
            line: 277,
            column: 81
          }
        }],
        line: 276
      },
      "19": {
        loc: {
          start: {
            line: 281,
            column: 17
          },
          end: {
            line: 281,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 17
          },
          end: {
            line: 281,
            column: 37
          }
        }, {
          start: {
            line: 281,
            column: 41
          },
          end: {
            line: 281,
            column: 43
          }
        }],
        line: 281
      },
      "20": {
        loc: {
          start: {
            line: 282,
            column: 24
          },
          end: {
            line: 282,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 282,
            column: 24
          },
          end: {
            line: 282,
            column: 40
          }
        }, {
          start: {
            line: 282,
            column: 44
          },
          end: {
            line: 282,
            column: 46
          }
        }],
        line: 282
      },
      "21": {
        loc: {
          start: {
            line: 285,
            column: 13
          },
          end: {
            line: 294,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 13
          },
          end: {
            line: 285,
            column: 33
          }
        }, {
          start: {
            line: 286,
            column: 14
          },
          end: {
            line: 293,
            column: 32
          }
        }],
        line: 285
      },
      "22": {
        loc: {
          start: {
            line: 287,
            column: 17
          },
          end: {
            line: 289,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 287,
            column: 17
          },
          end: {
            line: 287,
            column: 48
          }
        }, {
          start: {
            line: 288,
            column: 18
          },
          end: {
            line: 288,
            column: 100
          }
        }],
        line: 287
      },
      "23": {
        loc: {
          start: {
            line: 290,
            column: 17
          },
          end: {
            line: 292,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 290,
            column: 17
          },
          end: {
            line: 290,
            column: 47
          }
        }, {
          start: {
            line: 291,
            column: 18
          },
          end: {
            line: 291,
            column: 101
          }
        }],
        line: 290
      },
      "24": {
        loc: {
          start: {
            line: 295,
            column: 13
          },
          end: {
            line: 297,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 295,
            column: 13
          },
          end: {
            line: 295,
            column: 43
          }
        }, {
          start: {
            line: 296,
            column: 14
          },
          end: {
            line: 296,
            column: 77
          }
        }],
        line: 295
      },
      "25": {
        loc: {
          start: {
            line: 296,
            column: 32
          },
          end: {
            line: 296,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 296,
            column: 32
          },
          end: {
            line: 296,
            column: 52
          }
        }, {
          start: {
            line: 296,
            column: 56
          },
          end: {
            line: 296,
            column: 58
          }
        }],
        line: 296
      },
      "26": {
        loc: {
          start: {
            line: 304,
            column: 15
          },
          end: {
            line: 304,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 15
          },
          end: {
            line: 304,
            column: 32
          }
        }, {
          start: {
            line: 304,
            column: 36
          },
          end: {
            line: 304,
            column: 38
          }
        }],
        line: 304
      },
      "27": {
        loc: {
          start: {
            line: 305,
            column: 21
          },
          end: {
            line: 305,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 21
          },
          end: {
            line: 305,
            column: 37
          }
        }, {
          start: {
            line: 305,
            column: 41
          },
          end: {
            line: 305,
            column: 43
          }
        }],
        line: 305
      },
      "28": {
        loc: {
          start: {
            line: 323,
            column: 53
          },
          end: {
            line: 323,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 323,
            column: 53
          },
          end: {
            line: 323,
            column: 77
          }
        }, {
          start: {
            line: 323,
            column: 81
          },
          end: {
            line: 323,
            column: 83
          }
        }],
        line: 323
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0],
      "10": [0, 0, 0, 0],
      "11": [0, 0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0, 0, 0, 0, 0],
      "15": [0, 0, 0],
      "16": [0, 0, 0],
      "17": [0, 0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5e33594a5f2f80933473389ddddef2de46ee70a5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2fup6np0g4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2fup6np0g4();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ICON_SIZE = (cov_2fup6np0g4().s[0]++, 16);
var Wrapper = (cov_2fup6np0g4().s[1]++, _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: ", ";\n  justify-content: ", ";\n  position: relative;\n  &.performance {\n    flex-wrap: nowrap;\n    @media (max-width: 30em) {\n      display: block;\n    }\n  }\n  &.demand {\n    @media (max-width: 30em) {\n      float: right;\n    }\n  }\n  .g-price {\n    @media (max-width: 30em) {\n      text-align: left;\n      width: 100%;\n      font-weight: bold;\n      line-height: 26px;\n    }\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[0]++;
  cov_2fup6np0g4().s[2]++;
  return props.column ? (cov_2fup6np0g4().b[0][0]++, 'column') : (cov_2fup6np0g4().b[0][1]++, 'row');
}, function (props) {
  cov_2fup6np0g4().f[1]++;
  cov_2fup6np0g4().s[3]++;
  return props.center ? (cov_2fup6np0g4().b[1][0]++, 'center') : (cov_2fup6np0g4().b[1][1]++, 'flex-start');
}));

/* Style for Performance */
var Picture = (cov_2fup6np0g4().s[4]++, _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  min-width: 3.125rem;\n  min-height: 3.125rem;\n  margin-right: ", ";\n  background-size: cover;\n  background-position: center;\n  float: left;\n  @media (max-width: 30em) {\n    text-align: center;\n    display: block;\n    float: none;\n    margin: 0 auto;\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[2]++;
  cov_2fup6np0g4().s[5]++;
  return (cov_2fup6np0g4().b[3][0]++, props.image) && (cov_2fup6np0g4().b[3][1]++, props.image.small) ? (cov_2fup6np0g4().b[2][0]++, props.image.small) : (cov_2fup6np0g4().b[2][1]++, '');
}, _stylingConstants.default.spacing.small));
var ListViewName = (cov_2fup6np0g4().s[6]++, _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  @media (max-width: 30em) {\n    text-align: center;\n    margin: ", " 0;\n  }\n"])), _stylingConstants.default.spacing.small));

/* Style for DateTime */
var Date = (cov_2fup6np0g4().s[7]++, _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  float: left;\n  color: ", ";\n  @media (max-width: 30em) {\n    text-align: center;\n  }\n"])), _stylingConstants.default.color.baseText));
var Time = (cov_2fup6np0g4().s[8]++, _styledComponents.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  @media (max-width: 30em) {\n    text-align: center;\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[3]++;
  cov_2fup6np0g4().s[9]++;
  return (cov_2fup6np0g4().b[4][0]++, props.theme) && (cov_2fup6np0g4().b[4][1]++, props.theme.product) && (cov_2fup6np0g4().b[4][2]++, props.theme.product.descriptionColor) || (cov_2fup6np0g4().b[4][3]++, _stylingConstants.default.color.baseSubTitle);
}));

/* Style for Description */
var ContainerDescription = (cov_2fup6np0g4().s[10]++, _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n"]))));
var ContainerIcons = (cov_2fup6np0g4().s[11]++, _styledComponents.default.div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  min-width: 50px;\n"]))));
var Description = (cov_2fup6np0g4().s[12]++, _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: bold;\n  color: ", ";\n  display: table-cell;\n  padding-right: 45px;\n"])), function (props) {
  cov_2fup6np0g4().f[4]++;
  cov_2fup6np0g4().s[13]++;
  return (cov_2fup6np0g4().b[5][0]++, props.theme) && (cov_2fup6np0g4().b[5][1]++, props.theme.product) && (cov_2fup6np0g4().b[5][2]++, props.theme.product.descriptionColor) || (cov_2fup6np0g4().b[5][3]++, _stylingConstants.default.color.baseSubTitle);
}));
var IconDescription = (cov_2fup6np0g4().s[14]++, _styledComponents.default.div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  right: 2rem;\n  top: 0;\n  &:hover {\n    cursor: pointer;\n  }\n  span svg {\n    fill: ", ";\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[5]++;
  cov_2fup6np0g4().s[15]++;
  return (cov_2fup6np0g4().b[6][0]++, props.theme.button) && (cov_2fup6np0g4().b[6][1]++, props.theme.product.fillSvg) || (cov_2fup6np0g4().b[6][2]++, _stylingConstants.default.color.boxBackground);
}));
var LongDescription = (cov_2fup6np0g4().s[16]++, _styledComponents.default.div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  padding-top: 1.5rem;\n  color: ", ";\n"])), function (props) {
  cov_2fup6np0g4().f[6]++;
  cov_2fup6np0g4().s[17]++;
  return (cov_2fup6np0g4().b[7][0]++, props.theme) && (cov_2fup6np0g4().b[7][1]++, props.theme.product) && (cov_2fup6np0g4().b[7][2]++, props.theme.product.descriptionColor) || (cov_2fup6np0g4().b[7][3]++, _stylingConstants.default.color.baseSubTitle);
}));
var IconGender = (cov_2fup6np0g4().s[18]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductColumnType-icon-gender'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  margin: 0.625rem 0;\n  background-repeat: no-repeat;\n  background-image: ", ";\n  background-position: center;\n  width: 1.563rem;\n  min-width: 1.5rem;\n  height: 1.563rem;\n"])), function (props) {
  cov_2fup6np0g4().f[7]++;
  cov_2fup6np0g4().s[19]++;
  return "url(".concat(_icons.default[props.gender], ")");
}));
var IconMedal = (cov_2fup6np0g4().s[20]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductColumnType-icon-medal'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  margin: 0.625rem 0.625rem 0.625rem 0;\n  background-image: ", ";\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 1.563rem;\n  min-width: 1.5rem;\n  height: 1.563rem;\n"])), function (props) {
  cov_2fup6np0g4().f[8]++;
  cov_2fup6np0g4().s[21]++;
  return props.active ? (cov_2fup6np0g4().b[8][0]++, 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAACT0lEQVQYGUXBW4iMUQDA8f853/m+me8yFtmxudfKJUrrko0XD9KmPHqSkhSl1ouSeFJI4ZEnj4oovGx5IVskuT1Y5LYua9nZ3flmdmZnZ+ac7xxF2t9PiLt9qe/rPEpjmznMs305vmyCfE2jjAUBTjSVH7RDKW0OJyDXAuHGAI3nOkAU+EdIQPKXQAqrReYfxMkDCFtjlpOmHfyw1sMKg9FhKlY/GCRJXwDz+E84IW0r3NWuFW62ncZ4jUkb1gVZEOFEjVkvVT6Y+Wwy76GpLN3Nt82XGdqpceoQSsfgkLivDg57HCwShVPVhZMrq9O3zj+xzTlHKKTHQBRw8qfTcT/twqB61PWRON/6ZET+ev/iN1ffNuOdKlf2AtUen5ernz3aff/emsIoatvTafCA7EPjzJYTv6Z0VG01lYikedmbez9cTL94pGTCXYkgY8nYNKdGKnZP0adLBpHsXN+bBdGilOEPJ/nx/JpwV6JlaZmLWY69C7qXgUoAi62UqDdaJKuPfJfjw3uFuxSdq8DxuWtW+SQrwJRB5CEpQuk15VKN+T2nBySO/XOXL/BZtB7UJOjvkI1C5nDhWpJggkb57Q6FwycKwXM00hRFAm2LnnlPoLoICp3UZ8Z9CbzAOAgUQliCyGFMSuR/xO8UoAKMMamkwWX9uzpCtYaVq5ieitGtBNGxEaSg8nOEeOHW2xIrH6RjzX777vFETIM47KSjuA50jBt6RontA9HiHecUwrqi4U79U13b9NWJZE6+J5N4tdJUZSLccMN1910Q6N9/AKNJDlN3ie+mAAAAAElFTkSuQmCC)') : (cov_2fup6np0g4().b[8][1]++, '');
}));
var Code = (cov_2fup6np0g4().s[22]++, _styledComponents.default.div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-weight: normal;\n  text-transform: uppercase;\n"])), function (props) {
  cov_2fup6np0g4().f[9]++;
  cov_2fup6np0g4().s[23]++;
  return (cov_2fup6np0g4().b[9][0]++, props.theme) && (cov_2fup6np0g4().b[9][1]++, props.theme.product) && (cov_2fup6np0g4().b[9][2]++, props.theme.product.descriptionColor) || (cov_2fup6np0g4().b[9][3]++, _stylingConstants.default.color.baseSubTitle);
}));

/* Style for Venue */
var Venue = (cov_2fup6np0g4().s[24]++, _styledComponents.default.div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  float: left;\n  color: ", ";\n  @media (max-width: 30em) {\n    text-align: center;\n  }\n"])), _stylingConstants.default.color.baseText));
var Zone = (cov_2fup6np0g4().s[25]++, _styledComponents.default.div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  @media (max-width: 30em) {\n    text-align: center;\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[10]++;
  cov_2fup6np0g4().s[26]++;
  return (cov_2fup6np0g4().b[10][0]++, props.theme) && (cov_2fup6np0g4().b[10][1]++, props.theme.product) && (cov_2fup6np0g4().b[10][2]++, props.theme.product.descriptionColor) || (cov_2fup6np0g4().b[10][3]++, _stylingConstants.default.color.baseSubTitle);
}));
var SelectButton = (cov_2fup6np0g4().s[27]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'stx-ProductColumnType-button-select'
})(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n  @media (max-width: 30em) {\n    width: 100%;\n    display: block;\n  }\n"]))));

/**
 * Return a color according the type of demand
 * @param {string} type value of the demand
 * @returns {string} color for the button
 */
cov_2fup6np0g4().s[28]++;
var calculateColorDemand = function calculateColorDemand(type) {
  cov_2fup6np0g4().f[11]++;
  cov_2fup6np0g4().s[29]++;
  switch (type.toLowerCase()) {
    case 'good':
      cov_2fup6np0g4().b[11][0]++;
      cov_2fup6np0g4().s[30]++;
      return _stylingConstants.default.color.positive;
    case 'limited':
      cov_2fup6np0g4().b[11][1]++;
      cov_2fup6np0g4().s[31]++;
      return _stylingConstants.default.color.warning;
    case 'none':
      cov_2fup6np0g4().b[11][2]++;
      cov_2fup6np0g4().s[32]++;
      return _stylingConstants.default.color.negative;
    default:
      cov_2fup6np0g4().b[11][3]++;
      cov_2fup6np0g4().s[33]++;
      return _stylingConstants.default.color.negative;
  }
};

/* Style for Demand */
var _ref = (cov_2fup6np0g4().s[34]++, _stylingConstants.default),
  border = _ref.border,
  font = _ref.font;
cov_2fup6np0g4().s[35]++;
var getFontSize = function getFontSize(props) {
  cov_2fup6np0g4().f[12]++;
  cov_2fup6np0g4().s[36]++;
  return (cov_2fup6np0g4().b[12][0]++, props.theme.button) && (cov_2fup6np0g4().b[12][1]++, props.theme.button.textSize) || (cov_2fup6np0g4().b[12][2]++, font.sizeMS);
};
var Demand = (cov_2fup6np0g4().s[37]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_2fup6np0g4().f[13]++;
    cov_2fup6np0g4().s[38]++;
    return props.type ? (cov_2fup6np0g4().b[13][0]++, "stx-ProductColumnType-demand-".concat(props.type)) : (cov_2fup6np0g4().b[13][1]++, '');
  }
})(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  display: inline-block;\n  padding: 0 1rem;\n  color: ", ";\n  border: ", " solid transparent;\n  ", " max-width: 100%;\n  text-align: center;\n  @media (max-width: 30em) {\n    float: right;\n  }\n"])), function (props) {
  cov_2fup6np0g4().f[14]++;
  cov_2fup6np0g4().s[39]++;
  return calculateColorDemand(props.type);
}, _stylingConstants.default.color.boxText, border.widthBase, function (props) {
  cov_2fup6np0g4().f[15]++;
  cov_2fup6np0g4().s[40]++;
  return "line-height: calc(3 * ".concat(getFontSize(props), " - ").concat(border.widthBase, " * 2);");
}));

/*
* Component to display inside a column a value, the props are:
* - type: indicate the type of column between:
*       - performance
*       - dateTime
*       - description
*       - venue
*       - price
*       - demand
*       - options (it will contain a button that handle an action)
* - item: data of column
*/
var ProductColumnType = /*#__PURE__*/function (_Component) {
  function ProductColumnType(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ProductColumnType);
    cov_2fup6np0g4().f[16]++;
    cov_2fup6np0g4().s[41]++;
    _this = _callSuper(this, ProductColumnType, [props]);
    cov_2fup6np0g4().s[42]++;
    _this.state = {
      longDescriptionOpen: false
    };
    return _this;
  }
  (0, _inherits2.default)(ProductColumnType, _Component);
  return (0, _createClass2.default)(ProductColumnType, [{
    key: "toggleDescription",
    value: function toggleDescription() {
      cov_2fup6np0g4().f[17]++;
      cov_2fup6np0g4().s[43]++;
      this.setState(function (prevState) {
        cov_2fup6np0g4().f[18]++;
        cov_2fup6np0g4().s[44]++;
        return {
          longDescriptionOpen: !prevState.longDescriptionOpen
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_2fup6np0g4().f[19]++;
      var _ref2 = (cov_2fup6np0g4().s[45]++, this.props),
        type = _ref2.type,
        product = _ref2.product,
        performance = _ref2.performance,
        currencyCode = _ref2.currencyCode;
      cov_2fup6np0g4().s[46]++;
      switch (type) {
        case 'performance':
          cov_2fup6np0g4().b[14][0]++;
          cov_2fup6np0g4().s[47]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            className: "performance",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 253,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(Picture, (0, _extends2.default)({}, product, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 254,
              columnNumber: 13
            }
          })), /*#__PURE__*/_react.default.createElement(ListViewName, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 255,
              columnNumber: 13
            }
          }, (cov_2fup6np0g4().b[15][0]++, performance) && (cov_2fup6np0g4().b[15][1]++, performance.name) || (cov_2fup6np0g4().b[15][2]++, '')));
        case 'dateTime':
          cov_2fup6np0g4().b[14][1]++;
          cov_2fup6np0g4().s[48]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            column: true,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 260,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(Date, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 261,
              columnNumber: 13
            }
          }, (0, _format.default)(performance.start, 'dddd, DD MMMM YYYY')), /*#__PURE__*/_react.default.createElement(Time, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 262,
              columnNumber: 13
            }
          }, (0, _format.default)(performance.timeStart, 'HH:mm'), " - ", (0, _format.default)(performance.timeEnd, 'HH:mm')));
        case 'description':
          cov_2fup6np0g4().b[14][2]++;
          cov_2fup6np0g4().s[49]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 269,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(ContainerDescription, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 270,
              columnNumber: 13
            }
          }, /*#__PURE__*/_react.default.createElement(ContainerIcons, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 271,
              columnNumber: 15
            }
          }, (cov_2fup6np0g4().b[16][0]++, performance.gender) && (cov_2fup6np0g4().b[16][1]++, performance.gender === 'male') && (cov_2fup6np0g4().b[16][2]++, /*#__PURE__*/_react.default.createElement(IconGender, {
            gender: "male",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 273,
              columnNumber: 52
            }
          })), (cov_2fup6np0g4().b[17][0]++, performance.gender) && (cov_2fup6np0g4().b[17][1]++, performance.gender === 'female') && (cov_2fup6np0g4().b[17][2]++, /*#__PURE__*/_react.default.createElement(IconGender, {
            gender: "female",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 275,
              columnNumber: 54
            }
          })), (cov_2fup6np0g4().b[18][0]++, performance.gender) && (cov_2fup6np0g4().b[18][1]++, performance.gender === 'mixed') && (cov_2fup6np0g4().b[18][2]++, /*#__PURE__*/_react.default.createElement(IconGender, {
            gender: "mixed",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 277,
              columnNumber: 53
            }
          })), /*#__PURE__*/_react.default.createElement(IconMedal, {
            active: performance.medal,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 278,
              columnNumber: 17
            }
          })), /*#__PURE__*/_react.default.createElement(Description, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 280,
              columnNumber: 15
            }
          }, (cov_2fup6np0g4().b[19][0]++, performance.subtitle) || (cov_2fup6np0g4().b[19][1]++, ''), /*#__PURE__*/_react.default.createElement(Code, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 282,
              columnNumber: 17
            }
          }, "[", (cov_2fup6np0g4().b[20][0]++, performance.code) || (cov_2fup6np0g4().b[20][1]++, ''), "]"))), (cov_2fup6np0g4().b[21][0]++, performance.subtitle) && (cov_2fup6np0g4().b[21][1]++, /*#__PURE__*/_react.default.createElement(IconDescription, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 286,
              columnNumber: 15
            }
          }, (cov_2fup6np0g4().b[22][0]++, !this.state.longDescriptionOpen) && (cov_2fup6np0g4().b[22][1]++, /*#__PURE__*/_react.default.createElement(_icon.default, {
            size: ICON_SIZE,
            iconName: "plus",
            onClick: function onClick() {
              cov_2fup6np0g4().f[20]++;
              cov_2fup6np0g4().s[50]++;
              return _this2.toggleDescription();
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 288,
              columnNumber: 19
            }
          })), (cov_2fup6np0g4().b[23][0]++, this.state.longDescriptionOpen) && (cov_2fup6np0g4().b[23][1]++, /*#__PURE__*/_react.default.createElement(_icon.default, {
            size: ICON_SIZE,
            iconName: "minus",
            onClick: function onClick() {
              cov_2fup6np0g4().f[21]++;
              cov_2fup6np0g4().s[51]++;
              return _this2.toggleDescription();
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 291,
              columnNumber: 19
            }
          })))), (cov_2fup6np0g4().b[24][0]++, this.state.longDescriptionOpen) && (cov_2fup6np0g4().b[24][1]++, /*#__PURE__*/_react.default.createElement(LongDescription, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 296,
              columnNumber: 15
            }
          }, (cov_2fup6np0g4().b[25][0]++, performance.subtitle) || (cov_2fup6np0g4().b[25][1]++, ''))));
        case 'venue':
          cov_2fup6np0g4().b[14][3]++;
          cov_2fup6np0g4().s[52]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 302,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(Venue, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 303,
              columnNumber: 13
            }
          }, (cov_2fup6np0g4().b[26][0]++, performance.venue) || (cov_2fup6np0g4().b[26][1]++, ''), /*#__PURE__*/_react.default.createElement(Zone, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 305,
              columnNumber: 15
            }
          }, (cov_2fup6np0g4().b[27][0]++, performance.zone) || (cov_2fup6np0g4().b[27][1]++, ''))));
        case 'price':
          cov_2fup6np0g4().b[14][4]++;
          cov_2fup6np0g4().s[53]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 311,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(_price.default, {
            labelFrom: '',
            currencyCode: currencyCode,
            minAmount: performance.minAmount,
            maxAmount: performance.maxAmount,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 312,
              columnNumber: 13
            }
          }));
        case 'demand':
          cov_2fup6np0g4().b[14][5]++;
          cov_2fup6np0g4().s[54]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            center: true,
            className: "demand",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 322,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(Demand, {
            type: performance.availability,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 323,
              columnNumber: 13
            }
          }, (cov_2fup6np0g4().b[28][0]++, performance.availability) || (cov_2fup6np0g4().b[28][1]++, '')));
        case 'options':
          cov_2fup6np0g4().b[14][6]++;
          cov_2fup6np0g4().s[55]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 328,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(SelectButton, {
            href: performance.action.buy,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 329,
              columnNumber: 13
            }
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
            id: "gravity.Product.book",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 330,
              columnNumber: 15
            }
          })));
        default:
          cov_2fup6np0g4().b[14][7]++;
          cov_2fup6np0g4().s[56]++;
          return /*#__PURE__*/_react.default.createElement(Wrapper, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 335,
              columnNumber: 16
            }
          });
      }
    }
  }]);
}(_react.Component);
cov_2fup6np0g4().s[57]++;
ProductColumnType.propTypes = {
  /* Contain the product to render */
  product: _product.ProductType.isRequired,
  /* Contain the performance to render */
  performance: _product.PerformanceType.isRequired,
  /* String that indicates the type of column */
  type: _propTypes.default.string,
  /* Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string.isRequired
};
cov_2fup6np0g4().s[58]++;
ProductColumnType.defaultProps = {
  type: ''
};
var _default = exports.default = ProductColumnType;